import { render, staticRenderFns } from "./CommonIcon.vue?vue&type=template&id=559875d4&scoped=true&"
import script from "./CommonIcon.vue?vue&type=script&lang=ts&"
export * from "./CommonIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CommonIcon.vue?vue&type=style&index=0&id=559875d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559875d4",
  null
  
)

export default component.exports